import React from 'react';
// reactstrap components
import { Card, Col, ListGroup } from 'reactstrap';

import RichText from '../Common/RichText/RichText';
import ImageExpand from './ImageExpand';
import MCAnswerExam from './MCAnswerExam';

const POSSIBLE_POSITIONS = [1, 2, 3, 4];

class MCardExam extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  // Although the linter marks this as unused, it is used below (ListGroup1.doAnswer).
  doAnswer = (id) => {
    this.props.updateAnswer(this.props.id, id);
  };

  shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  };

  renderSymbols = (text) => {
    const isNewQuestion = /<\/?[a-z][\s\S]*>/i.test(text);
    let result = text;
    result = result.replace(/<\/p><p>/g, '<br>');
    if (!isNewQuestion) {
      result = result.replace(/</g, '&lt;');
      result = result.replace(/>/g, '&gt;');
    }
    return result;
  };

  getOrderedAnswers = (answers) => {
    // This, and the preview function are from v2
    if (!answers) {
      return '';
    }
    const currentPossitions = answers.map((a) => a.order);
    let remainingPositions = POSSIBLE_POSITIONS.filter(
      (p) => !currentPossitions.includes(p),
    );
    remainingPositions = this.shuffleArray(remainingPositions);
    const filteredAnswers = this.props.answers
      .map((a) => {
        if (a.text) {
          a.text = a.text.replace(/(?:&nbsp;|<br>|<p>|<[/]p>)/g, '');
        }
        return a;
      })
      .filter((a) => a.text || a.text === 0 || a.imageUrl)
      .map((a) => {
        if (a.order === 0) {
          a.order = remainingPositions.pop();
        }
        return a;
      })
      .sort((a, b) => a.order - b.order);
    return filteredAnswers;
  };

  render() {
    const ListGroup1 = this;
    const extraClass =
      this.props.number % 2 === 0 ? ' float-lg-right ' : ' float-lg-left ';
    const cardClass = `mt-lg-4 mt-sm-0 mcard mcard-exam ${extraClass}`;

    let answered = null;

    if (
      this.props.resultsSummarized &&
      Array.isArray(this.props.resultsSummarized) &&
      this.props.resultsSummarized.length > 0
    ) {
      const element = this.props.resultsSummarized.find(
        (r) => r.question === this.props.id,
      );
      if (element) {
        answered = element.answer;
      }
    }

    const htmlQuestion = `<h2>${this.props.number}. ${this.renderSymbols(
      this.props.text,
    )}</h2>`;

    const answers = this.getOrderedAnswers(this.props.answers);

    const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

    return (
      <div className={cardClass}>
        <div className="d-flex flex-row smallerImage">
          <RichText
            tag="span"
            className="questions-p mr-4"
            html={htmlQuestion}
          />
          <ImageExpand
            imageUrl={this.props.imageUrl}
            className="expanded-image-modal-exam"
          />
        </div>
        <Col className="col-12">
          <Card>
            <div className="d-flex flex-md-row flex-column flex-sm-column justify-content-center">
              <ListGroup className="pl-0">
                {answers.map((answer, index) =>
                  answer.text || answer.imageUrl ? (
                    <MCAnswerExam
                      doAnswer={ListGroup1.doAnswer}
                      graded={ListGroup1.props.graded}
                      char={alphabet[index]}
                      pts={answer.points}
                      text={answer.text}
                      key={answer.id}
                      answer={answer}
                      answered={answered}
                      questionNumber={this.props.questionNumber}
                      index={index}
                    />
                  ) : null,
                )}
              </ListGroup>
            </div>
          </Card>
        </Col>
      </div>
    );
  }
}

export default MCardExam;
